import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

try {
  const stored = localStorage.getItem('theme-storage')
  const raw = stored ? JSON.parse(stored)?.state?.isDarkMode : false
  const shouldUseDarkMode = raw === true || raw === 'true' || raw === 1

  document.documentElement.classList.toggle('dark', shouldUseDarkMode)
} catch {
  // default to light
}

Sentry.init({
  dsn: 'https://af4697eb7a289fb0389975dca0894fca@o4510780011577344.ingest.us.sentry.io/4510780703506432',
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    // Automatically capture console.error and console.warn as logs
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),
  ],
  // Set sample rate for performance monitoring (1.0 = 100% of transactions)
  tracesSampleRate: 1.0,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

